module.exports = __webpack_public_path__ + "static/img/添加图片.6ef05b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/添加图片.png
// module id = 1338
// module chunks = 382